/**
 * Utility to detect country based on identifier (phone or email)
 * or browser/system settings.
 */

export type CountryCode = 'Nigeria' | 'USA' | 'UK' | 'Ghana' | 'Other';

export interface CountryInfo {
  name: CountryCode;
  currency: string;
  flag: string;
  phonePrefix: string;
}

export const COUNTRIES: Record<CountryCode, CountryInfo> = {
  Nigeria: { name: 'Nigeria', currency: '₦', flag: '🇳🇬', phonePrefix: '+234' },
  USA: { name: 'USA', currency: '$', flag: '🇺🇸', phonePrefix: '+1' },
  UK: { name: 'UK', currency: '£', flag: '🇬🇧', phonePrefix: '+44' },
  Ghana: { name: 'Ghana', currency: 'GH₵', flag: '🇬🇭', phonePrefix: '+233' },
  Other: { name: 'Other', currency: '$', flag: '🌐', phonePrefix: '' }
};

export function detectCountry(identifier?: string): CountryCode {
  if (identifier) {
    // Check phone prefix
    if (identifier.startsWith('+234') || (identifier.startsWith('0') && identifier.length === 11)) return 'Nigeria';
    if (identifier.startsWith('+1')) return 'USA';
    if (identifier.startsWith('+44')) return 'UK';
    if (identifier.startsWith('+233')) return 'Ghana';

    // Check email TLD
    if (identifier.endsWith('.ng')) return 'Nigeria';
    if (identifier.endsWith('.uk')) return 'UK';
    if (identifier.endsWith('.gh')) return 'Ghana';
    
    // Default to Nigeria if it looks like a Nigerian phone number without prefix
    if (/^\d{11}$/.test(identifier)) return 'Nigeria';
  }

  // Always default to Nigeria for Sentlo (Nigerian-focused app)
  console.log('🌍 Sentlo: Defaulting to Nigeria');
  return 'Nigeria';
}

export function getCurrency(country: CountryCode): string {
  return COUNTRIES[country]?.currency || '₦';
}